<div
  class="mib-modal max-h-[90dvh] flex flex-col h-full gap-4 max-lg:landscape:gap-2"
  role="dialog">
  <header class="shrink-0">
    <mai-mib-logo></mai-mib-logo>
  </header>

  <!-- Always visible — does not scroll -->
  <p class="shrink-0 text-sm font-normal leading-5 text-branding-900 wrap-break-word">
    For educational use only. Responses are informational, not medical advice. AI systems can
    make mistakes. Final responsibility for clinical decisions always rests with the human
    professional. A new and evolving educational tool, presented for discussion.
  </p>

  <!-- Scrollable area: guest form + terms -->
  <div
    class="min-h-0 flex-1 overflow-y-auto mib-scrollbar pr-4 -mr-4 max-lg:landscape:pr-2 max-lg:landscape:-mr-2">
    <div class="dialog-content text-(--mib-dialog-text-color) flex flex-col gap-4">
      @if (showGuestForm()) {
        <div>
          <h2 class="text-2xl max-lg:landscape:mt-4 max-lg:landscape:text-xl text-branding-900">
            Guest Access - Terms and Information
          </h2>
          <div class="pb-8 border-b border-gray-300">
            <p class="font-medium mb-4 text-branding-900">
              Please provide your information to continue:
            </p>
            <mai-guest-disclaimer-form
              [formData]="data?.formData"
              (formSubmitted)="onGuestFormSubmitted($event)"></mai-guest-disclaimer-form>
          </div>
        </div>
      }
      <h3 class="mb-2 text-2xl text-branding-900">
        Welcome to the Medinbox AI Live Session.
      </h3>
      <p>
        You are about to join a live medical session made available for educational and evaluation
        purposes only.
      </p>
      <p>
        By continuing, you confirm that you are a healthcare professional, or are otherwise
        authorized to access this session for legitimate professional or educational purposes. This
        platform provides access to live medical content intended exclusively for training,
        education, and information sharing among healthcare professionals.
      </p>
      <p>
        During this session you may interact in real time with the integrated Medinbox AI assistant
        by text chat or voice. All AI responses are for informational purposes only and may be
        inaccurate, incomplete, or outdated. They must not be interpreted as medical advice,
        diagnosis, or treatment recommendations. You remain fully responsible for your own
        professional judgment and must follow applicable clinical protocols and institutional
        guidelines. This content is not intended for diagnostic, therapeutic, or real-time clinical
        use, and must never replace consultation with a qualified physician.
      </p>
      <p>
        Do not enter any information that could identify a patient, such as a name, date of birth,
        or medical record number. Use this tool only with anonymized or hypothetical information.
      </p>
      <p>
        <span class="font-medium">Data processing.</span> By clicking "I accept", you consent to
        Medinbox processing the information you provide (your name and email) and the content of your
        interactions with the AI assistant, meaning your text and voice inputs and the corresponding
        AI responses. This data is processed only to operate and identify your session and for
        quality, compliance, and security purposes. Your interactions are not used to train or
        develop AI models. To deliver the real-time text and voice features, your inputs are
        processed by Medinbox and by its technical service providers, acting solely on Medinbox's
        instructions and under contract. Medinbox does not sell your data and does not share it for
        marketing purposes.
      </p>
      <p>
        Your data may be processed outside your country, including in the United States, under
        appropriate safeguards. Interaction logs are retained for 12 months and then deleted. Your
        name and email are kept only for as long as needed to manage your access and are deleted
        within the same period. You may request access to, correction of, or deletion of your data,
        or withdraw your consent, at any time by contacting privacy@medinbox.com. The data controller
        is Medinbox SAS. For full details, see our
        <button
          type="button"
          class="underline font-medium text-branding-900 hover:no-underline"
          (click)="openPrivacyPolicy($event)">
          Privacy Policy</button>.
      </p>
      <p>
        <span class="font-medium">Intellectual property.</span> All live content and associated
        materials remain the exclusive property of their respective authors and institutions,
        protected by intellectual property laws. They must not be copied, recorded, distributed, or
        shared in any form without prior written authorization from Medinbox or the rightful content
        owners.
      </p>
      <p>
        By clicking "I accept", you confirm that you understand and agree to these terms, that you
        consent to your interactions being logged and processed as described above, and that you will
        use this system solely for legitimate educational and evaluation purposes.
      </p>
    </div>
  </div>

  <footer class="shrink-0 flex w-full justify-center gap-4">
    <mib-button class="w-full" theme="secondary" (click)="onRefuse()">I refuse</mib-button>
    <mib-button class="w-full" [disabled]="showGuestForm() && !isFormValid()" (click)="onAccept()"
      >I accept</mib-button
    >
  </footer>
</div>
